module.exports = __webpack_public_path__ + "static/img/logo@3x.0c41b7fd.png";